export enum PermissionsConsts {
  PERMISSIONS_LIST = 'PERMISSIONS:LIST',
  PERMISSIONS_LIST_OK = 'PERMISSIONS:LIST:OK',
  PERMISSIONS_LIST_KO = 'PERMISSIONS:LIST:KO',
}
